import { render, staticRenderFns } from "./StudentConfirm.vue?vue&type=template&id=460d4b9e&scoped=true&lang=pug&"
import script from "./StudentConfirm.vue?vue&type=script&lang=ts&"
export * from "./StudentConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./StudentConfirm.vue?vue&type=style&index=0&id=460d4b9e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460d4b9e",
  null
  
)

export default component.exports